// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import QRCode from '../../_common/api/QRCode';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Cart from '../../_common/Cart';
import Button from '../../_common/form/Button';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Modal from '../../_common/Modal';
import Card from '../Card';
import airPAY from '../../../assets/images/airPAY.png'
import CountDown from '../../_common/CountDown';
import styled from 'styled-components';
import Loading from '../../_common/Loading';
import { HamQuest } from '../../../App';

const PaddedDiv = styled.div`
    padding: 0.5em 0;
`

const AirPay = () => {
    const { state: {
        active_user,
        site_config
    } } = useGlobalState();

    const [token, setToken] = useState(false)

    const generateToken = () => {
        HamQuest.post(QuestRoute.tempToken, {
            TempIdType: 'TempToken'
        })
            .then((res) => {
                if (!res.tempId) throw res.error;
                setToken(res.tempId)
            })
            .catch(ex => {
                console.log(ex)
                Modal.Show({
                    type: 'error',
                    title: 'Unable to Generate Token',
                    body: ex.blob.error || 'Sorry, something went wrong. Please try again.'
                })
            })
    }

    useEffect(() => {
        if (!active_user.payment) return;
        generateToken();
    }, [])

    return (
        <Card title='AirPAY' icon='QRcode'>
            {
                !active_user.payment ?
                    <>
                        <img src={airPAY} alt='AirPAYimg' />
                        <br />
                        <PaddedDiv>
                            <b>AirPAY</b> gives you a quick and easy way to purchase services at our {site_config.companyName} locations. It's much like swiping a credit card only more secure! <br />
                            Once you register your credit/debit card with is, simply tap the AirPay button whenever you are ready to buy a wash. <br />
                            A unique code will be generated for you, which can then be scanned at the barcode reader of any of our kiosks. <br />
                            Your payment method will be charged and your service will then begin! A receipt is automatically emailed to you with every transaction.
                        </PaddedDiv>
                        <Button onClick={() => Cart.AddCardToAccount()}>Set Up AirPAY</Button>
                    </> :
                    token ?
                        <>
                            <QRCode data={token} />
                            <CountDown type='bar' time={30} callback={() => setToken(null)} />
                            <PaddedDiv>
                                It's much like swiping a credit card only more secure! The card you have registered with us will be charged for this transaction.
                            </PaddedDiv>
                        </> : token === false ?
                            <Loading /> :
                            <>
                                <PaddedDiv>Token expired. Please generate a new token to use AirPAY.</PaddedDiv>
                                <Button onClick={() => generateToken()}>Generate a new Token</Button>
                            </>
            }
        </Card>
    );
}

export default AirPay;